import API from "../../utils/API";

export default {
  updateCartOrderNum({ commit }, updateValue) {
    commit("updateCartOrderNum", updateValue);
  },
  updataSingleSpecialMemberData({ commit }, { updateKey, updateValue }) {
    commit("updataSingleSpecialMemberData", { updateKey, updateValue });
  },
  async specialMemberApply(context, data) {
    let response = await API.frontPOST(`/users/special-member`, data);
    return response;
  },
  async tokenGetSpecialMemberData({ commit }) {
    let response = await API.frontGET(`/users/special-member/show`);
    return commit("updataSpecialMemberData", response.data);
  },
  async saveSpecialMemberData(context, updateData) {
    let response = await API.frontPUT(`/users/special-member`, updateData);
    return response;
  },
  async getUploadRemoteData(context, numberData) {
    let response = await API.frontGET(`/urls`, numberData);
    return response;
  },
  async specialMemberSendPayInfo(context, payInfo) {
    let response = await API.frontPOST(
      `/orders/${payInfo.id}/report`,
      payInfo.data
    );
    return response;
  },
  async getAccessoryList() {
    let response = await API.frontGET(`/accessories`);
    return response;
  },
  async renewOrder({ commit }, renewOldId) {
    let response = await API.frontPOST(`/orders/${renewOldId}/renew`);
    commit("setRenewOrderData", response.data.order[0]);
    return response.data.order[0].id;
  },
  async renewCheckout(context, payload) {
    let response = await API.frontPOST(
      `orders/${payload.newId}/renewCheck/${payload.oldId}`
    );
    return response;
  },
  async getGoldPrice() {
    let response = await API.frontGET(`/gold/pricing`);
    return response;
  },
};
